import { DEFAULT_FG } from "./colors.js";

export const canvas = document.getElementById('terminal');
export const ctx = canvas.getContext('2d');

// Logical display constants.
export const logicalWidth = 320;
export const logicalHeight = 200;
export const columns = 40;
export const rows = 25;
export const fps = 50;
export const cellWidth = logicalWidth / columns; // 8 pixels per cell.
export const cellHeight = logicalHeight / rows;   // 8 pixels per cell.

// Adjust canvas for high-DPI displays.
const dpr = window.devicePixelRatio || 1;
canvas.width = logicalWidth * dpr;
canvas.height = logicalHeight * dpr;
ctx.scale(dpr, dpr);

// Set our custom font and text baseline ("top" makes positioning easier).
ctx.font = "8px 'C64 Pro'";
ctx.textBaseline = "top";
ctx.fillStyle = DEFAULT_FG;